import { EDynamicColumnType, IDynamicColumnFilter } from "Interfaces/Utils";

export interface IDynamicFilters {
  filters: IDynamicColumnFilter[];
  externalFilterValues: Record<string, any>;
  filterData: (filters: Record<string, any>) => void;
  onOtherComponentChange?: (value: string) => void;
  resetGlobalFilters?: () => void;
};

export interface FilterValues {
  [key: string]: {
    value: string | null; 
    type: string;
  };
};

export const initializeFilterValues = (filters: IDynamicColumnFilter[]): FilterValues => {
  return filters.reduce((acc: FilterValues, filter: IDynamicColumnFilter) => {
    acc[filter.field] = {
      value: filter.type === EDynamicColumnType.DATE ? null : "",
      type: filter.type,
    };
    return acc;
  }, {});
};